module.exports = __webpack_public_path__ + "static/images/probtn.fd8cbce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/probtn.png
// module id = Fnjh
// module chunks = 11